module.exports = __webpack_public_path__ + "static/nia_logo_color_png.e685c137.png";